document.addEventListener("DOMContentLoaded", function () {
    menuDevelop();

/*=============================================>>>>>
= Appel de la gestion de cookies RGPD =
===============================================>>>>>*/
    let cookies = document.querySelector(".cookies");
    if (cookies != null) {
        cookies.addEventListener("click", function (e) {
            e.preventDefault();
            if (tarteaucitron) {
                tarteaucitron.userInterface.openPanel();
            }
        });
    }


/*=============================================>>>>>
= Topbut =
===============================================>>>>>*/
    let btn = document.querySelector("#topbut");
    if (btn != null) {
        window.addEventListener("scroll", function () {
            if (window.scrollY > 300) {
                btn.classList.add("visible");
            } else {
                btn.classList.remove("visible");
            }
        });
        btn.addEventListener("click", function (e) {
            e.preventDefault();
            document.querySelector("html").scrollTop = 0;
            document.querySelector("body").scrollTop = 0;
        });
    }


/*=============================================>>>>>
= Sliders =
===============================================>>>>>*/
    const sliderClients = document.querySelector('#clients');
    if (sliderClients) {
        const flktySliderClients = new Flickity(sliderClients, {
            "contain": true,
            "pageDots": false,
            "wrapAround": true,
            "draggable": false,
            "cellAlign": "center",
            "prevNextButtons": false,
            // "autoPlay": true,
            "autoPlay": 3000,
            "pauseAutoPlayOnHover": false
        });
    }

    const sliderPartenaires = document.querySelector('#partenaires');
    if (sliderPartenaires) {
        const flktysliderPartenaires = new Flickity(sliderPartenaires, {
            "contain": true,
            "pageDots": false,
            "wrapAround": true,
            "draggable": false,
            "cellAlign": "center",
            "prevNextButtons": false,
            // "autoPlay": true,
            "autoPlay": 3000,
            "pauseAutoPlayOnHover": false
        });
    }

    if ( matchMedia('screen and (min-width: 1200px)').matches ) {
        let elementsClients = document.querySelectorAll('.clients-slider.no-slider');
        for (let i = 0; i < elementsClients.length; i++) {
            let flktyClients = Flickity.data(elementsClients[i]);
            flktyClients.destroy();
        }
        let elementsPartenaires = document.querySelectorAll('.partenaires-slider.no-slider');
        for (let i = 0; i < elementsPartenaires.length; i++) {
            let flktyPartenaires = Flickity.data(elementsPartenaires[i]);
            flktyPartenaires.destroy();
        }
    }


/*=============================================>>>>>
= Contact form File Upload =
===============================================>>>>>*/
    const fileInput = document.querySelector('#file_upload');
    const fileSelected = document.querySelector('#file-selected');
    if (fileInput) {
        fileInput.addEventListener('change', function () {
            let fileName = '';
            fileName = this.value;
            fileSelected.innerHTML = fileName.replace(/^.*\\/, "");
        });
    }


/*=============================================>>>>>
= Filtre produits =
===============================================>>>>>*/
    let produits = document.querySelector('#produits');
    if (produits) {
        ajaxProduits();
    }

    let catListItems = document.querySelectorAll('.cat-list_item');
    if (catListItems) {
        catListItems.forEach(function (item) {
            item.addEventListener('click', function () {
                catListItems.forEach(function (item) {
                    item.classList.remove('active');
                });
                this.classList.add('active');
                ajaxProduits(this.dataset.slug, this.dataset.type);
            });
        });
    }

    let collapseTri = document.querySelector('.collapse-tri');
    if (collapseTri) {
        collapseTri.addEventListener('click', function () {
            let categoriesList = document.querySelector('#categories-list');
            categoriesList.classList.toggle('visible');
        });
    }



/*=============================================>>>>>
= Bloc vidéo Single Produit =
===============================================>>>>>*/
    window.addEventListener("DOMContentLoaded", function() {
        let embedContainer = document.querySelector(".embed-container");
        if (embedContainer) {
            let video = embedContainer.querySelector("iframe");
            let playIcon = embedContainer.querySelector(".play-icon");

            if (playIcon) {
                playIcon.addEventListener("click", function () {
                    video.src += "&autoplay=1";
                    playIcon.style.display = "none";
                });
            }
        }
    });





/*=============================================>>>>>
= Agrandissement des photos au clic =
===============================================>>>>>*/
    //     let photoModal = document.getElementById('photoModal');
    //     photoModal.addEventListener('show.bs.modal', function (event) {
    //     let link = event.relatedTarget;
    //     let photoUrl = link.getAttribute('data-photo-url');
    //     let modalImage = photoModal.querySelector('.modal-image');
    //     modalImage.setAttribute('src', photoUrl);
    // });





});
//Fin DOMContentLoaded


function menuDevelop () {

    //Pour fermer les sous-menus ouverts
    const body = document.querySelector("body");
    body.addEventListener("click", function(event) {
        const isDropdownItem = event.target.classList.contains("dropdown-item") || event.target.closest(".dropdown-item");
        if (!isDropdownItem) {
            const shownDropdowns = document.querySelectorAll(".dropdown-menu .show, .dropdown-submenu .show");
            shownDropdowns.forEach(dropdown => dropdown.classList.remove("show"));
        }
    });

    //Pour gérer les sous-menus
    const dropdownItems = document.querySelectorAll(".menu-item-has-children > .dropdown-item");
    dropdownItems.forEach(item => {
        item.addEventListener("click", function(event) {
            event.preventDefault();
            event.stopPropagation();

            const isDropdownShown = this.nextElementSibling.classList.contains("show");
            const parentDropdownMenu = this.closest(".dropdown-menu");

            if (!isDropdownShown) {
                const shownDropdown = parentDropdownMenu.querySelector(".show");
                if (shownDropdown) {
                    const childDropdowns = shownDropdown.querySelectorAll(".dropdown-menu .show");
                    childDropdowns.forEach(child => child.classList.remove("show"));
                    shownDropdown.classList.remove("show");
                }
            }

            this.nextElementSibling.classList.toggle("show");

            const parentDropdown = this.closest("li.nav-item.dropdown.show");
            if (parentDropdown) {
                parentDropdown.addEventListener("hidden.bs.dropdown", function(event) {
                    const shownDropdowns = document.querySelectorAll(".dropdown-menu .show, .dropdown-submenu .show");
                    shownDropdowns.forEach(dropdown => dropdown.classList.remove("show"));
                });
            }
        });
    });
}

function ajaxProduits(slug = "", type="produit", page = '1') {

    // Afficher le loader
    let loader = document.querySelector('.loader');
    loader.classList.add('visible');

    jQuery.ajax({
        type: 'POST',
        url: '/wp-admin/admin-ajax.php',
        dataType: 'html',
        data: {
            action: 'filter_produits',
            categorie: slug,
            type: type,
            page: page,
        },
        success: function (res) {
            if (res) {

                jQuery('#produits').html(res);
                // Cacher le loader
                loader.classList.remove('visible');

                let catActive = jQuery('.cat-list_item.active');
                let page = jQuery(".page-numbers").on("click", function (e) {
                    e.preventDefault();
                    ajaxProduits(catActive.data("slug"), 'produit', jQuery(this).data("page"));
                    scrollToResults();
                });
                scrollToResults();
            }


        }
    });

}

function scrollToResults() {
    var resultsSection = document.getElementById('breadcrumbs');
    if (resultsSection) {
        resultsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
}